"use client";

import Link from "next/link";
import { motion } from "framer-motion";
import { containerVariants, itemVariants } from "@/lib/animation-variants";

export default function Footer() {
  const handleSaveToCalendar = () => {
    // Use the static .ics file as single source of truth
    const link = document.createElement("a");
    link.href = "/downloads/AV-Gothia-150-Stiftungsfest.ics";
    link.download = "AV-Gothia-150-Stiftungsfest.ics";
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  return (
    <motion.div
      variants={containerVariants}
      initial="hidden"
      animate="visible"
      className="mt-auto flex w-full items-start justify-start gap-1 bg-gray-800 p-6 text-white"
      style={{
        paddingBottom: "max(1.5rem, env(safe-area-inset-bottom))",
      }}>
      <motion.div
        variants={itemVariants}
        className="flex flex-col items-start gap-4 sm:flex-row sm:items-end sm:gap-6">
        {/* Main event info - left aligned */}
        <div className="flex flex-col items-start sm:flex-row sm:items-end sm:gap-6">
          <span className="hidden text-left text-subheading text-white md:inline">
            150 Jahre AV Gothia
          </span>
          <span className="text-left text-subheading text-white md:hidden">
            AV Gothia 150. Stiftungsfest
          </span>
        </div>

        {/* Date and Links - all in one line, bottom aligned */}
        <div className="flex flex-col items-start gap-2 sm:flex-row sm:items-end sm:gap-6">
          <button
            onClick={handleSaveToCalendar}
            className="flex cursor-pointer items-center gap-1.5 text-left text-body text-gray-200 transition-colors duration-200 hover:text-gray-100 hover:underline"
            title="Termin in Kalender speichern">
            <svg
              className="h-4 w-4"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24">
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M4 16v1a3 3 0 003 3h10a3 3 0 003-3v-1m-4-4l-4 4m0 0l-4-4m4 4V4"
              />
            </svg>
            11.-14. Juni 2026
          </button>
          <span className="hidden text-white/60 sm:inline">•</span>
          <Link
            href="/datenschutz"
            className="flex items-center gap-1.5 text-left text-body text-gray-200 transition-colors duration-200 hover:text-gray-100 hover:underline">
            <svg
              className="h-4 w-4"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24">
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M13.828 10.172a4 4 0 00-5.656 0l-4 4a4 4 0 105.656 5.656l1.102-1.101m-.758-4.899a4 4 0 005.656 0l4-4a4 4 0 00-5.656-5.656l-1.1 1.1"
              />
            </svg>
            Datenschutz
          </Link>
          <span className="hidden text-white/60 sm:inline">•</span>
          <Link
            href="/mediakit"
            className="flex items-center gap-1.5 text-left text-body text-gray-200 transition-colors duration-200 hover:text-gray-100 hover:underline">
            <svg
              className="h-4 w-4"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24">
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M4 16v1a3 3 0 003 3h10a3 3 0 003-3v-1m-4-4l-4 4m0 0l-4-4m4 4V4"
              />
            </svg>
            Mediakit
          </Link>
          <span className="hidden text-white/60 sm:inline">•</span>
          <Link
            href="https://avgothia.de"
            target="_blank"
            rel="noopener noreferrer"
            className="flex items-center gap-1.5 text-left text-body text-gray-200 transition-colors duration-200 hover:text-gray-100 hover:underline">
            <svg
              className="h-4 w-4"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24">
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M10 6H6a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2v-4M14 4h6m0 0v6m0-6L10 14"
              />
            </svg>
            avgothia.de
          </Link>
        </div>
      </motion.div>
    </motion.div>
  );
}
